import {Record} from 'immutable';

import {makeReducer, match} from 'web-app/util/redux';

import * as Actions from './actions';

export class DirectDebitActivationState extends Record<{
    readonly isVisible: boolean;
    readonly directDebitInstructionId: string;
    readonly billPayerId?: string;
    readonly submitting: boolean;
    readonly isInternal: boolean;
    readonly isAutopayRequired?: boolean;
    readonly onSuccess?: () => void | Promise<void>;
}>({
    isVisible: false,
    directDebitInstructionId: '',
    billPayerId: undefined,
    submitting: false,
    isInternal: false,
    isAutopayRequired: false,
    onSuccess: () => undefined,
}) {}

export default makeReducer<DirectDebitActivationState>(
    [
        match(Actions.show, (state, {payload}) => {
            return new DirectDebitActivationState({
                isVisible: true,
                billPayerId: payload.billPayerId,
                isInternal: payload.isInternal,
                isAutopayRequired: payload.isAutopayRequired,
                onSuccess: payload.onSuccess,
            });
        }),
        match(Actions.setId, (state, {payload}) => {
            return state.merge({
                directDebitInstructionId: payload.directDebitInstructionId,
            });
        }),
        match(Actions.hide, state => {
            return state.merge({
                isVisible: false,
            });
        }),
        match(Actions.setSubmitting, (state, {payload}) => {
            return state.merge({
                submitting: payload.submitting,
            });
        }),
    ],
    new DirectDebitActivationState(),
);
